import { Paper, Skeleton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import React from 'react'

function TableSkeleton({ rowsNum = 8 }) {
    return (
        <TableContainer>
            <Table className='w-full p-4'>
                <TableHead className='bg-[#f6f9fc] rounded-[10px]'>
                    <TableRow>
                        <TableCell>
                            <Skeleton animation="wave" width="100%" variant="text" />
                        </TableCell>
                        <TableCell align="right">
                            <Skeleton animation="wave" width="100%" variant="text" />
                        </TableCell>
                        <TableCell align="right">
                            <Skeleton animation="wave" width="100%" variant="text" />
                        </TableCell>
                        <TableCell align="right">
                            <Skeleton animation="wave" width="100%" variant="text" />
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {[...Array(rowsNum)].map((row, index) => (
                        <TableRow className='w-full' key={index}>
                            <TableCell component="th" scope="row">
                                <Skeleton animation="wave" width="100%" variant="text" />
                            </TableCell>
                            <TableCell>
                                <Skeleton animation="wave" width="100%" variant="text" />
                            </TableCell>
                            <TableCell>
                                <Skeleton animation="wave" width="100%" variant="text" />
                            </TableCell>
                            <TableCell>
                                <Skeleton animation="wave" width="100%" variant="text" />
                            </TableCell>
                        </TableRow>
                    ))} 
                </TableBody>
            </Table>
        </TableContainer>
    )
}

export default TableSkeleton
  